import selectTemplate from './select/select.pug';
import viewTemplate from './view/view.pug';

'use strict';

export default ['$stateProvider', function routes($stateProvider) {
  $stateProvider
    .state('group.view.financialTransaction', {
    // /context/:ctxId/groups/:groupId/grouptransactions
    // :ctxId = ancestor/context group, :groupId = group
      url: '/financialtransactions',
      abstract: true,
      template: '<ui-view />'
    })
    .state('group.view.financialTransaction.select', {
      url: '/select',
      template: selectTemplate,
      controller: 'FinTxnSelectCtrl',
      controllerAs: 'ftvm',
      authenticate: true
    })
    .state('group.view.financialTransaction.view', {
      url: '/:ftId',
      template: viewTemplate,
      controller: 'FinTxnViewCtrl',
      controllerAs: 'ftvm',
      authenticate: true
    });
}];
